import { BlameLogType } from '@debbie/common/dist/blamelog/index.js';
import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import THEME from '../../../theme.js';
import ButtonDrop from '../../ButtonDrop.js';
import { Table } from '../../index.js';
import { Meta } from './style.js';
export const InteractionDetails = ({ blamelog }) => {
    const [open, setOpen] = useState(false);
    return (React.createElement(ButtonDrop, { open: open, onOpen: () => setOpen(true), onClose: () => setOpen(false), size: "mini", info: true, maxWidth: "500px", minWidth: "500px" },
        React.createElement(Meta, null,
            React.createElement(Table, { zebra: true },
                React.createElement(InteractionDetailsContent, { blamelog: blamelog })))));
};
const InteractionDetailsContent = ({ blamelog }) => {
    switch (blamelog.type) {
        case BlameLogType.InteractionCreate:
            return React.createElement(InteractionCreateContent, { blamelog: blamelog });
        case BlameLogType.InteractionDelete:
            return React.createElement(InteractionDeleteContent, { blamelog: blamelog });
        case BlameLogType.InteractionHideFromClient:
            return React.createElement(InteractionHideFromClientContent, { blamelog: blamelog });
        case BlameLogType.InteractionRollback:
            return React.createElement(InteractionRollbackContent, { blamelog: blamelog });
        case BlameLogType.InteractionMappedToCase:
            return React.createElement(InteractionMappedToCaseContent, { blamelog: blamelog });
        case BlameLogType.InteractionUnmappedFromCase:
            return React.createElement(InteractionUnmappedFromCaseContent, { blamelog: blamelog });
        default:
            return null;
    }
};
const InteractionCreateContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    return (React.createElement(React.Fragment, null,
        React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.type)),
            React.createElement("td", null, lang.interactionTypes[details.interactionType] ||
                details.interactionType)),
        React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.direction)),
            React.createElement("td", null, lang.interactions[details.direction] ||
                details.direction))));
};
const InteractionDeleteContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    return (React.createElement(React.Fragment, null,
        React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.type)),
            React.createElement("td", null, lang.interactionTypes[details.type] ||
                details.type)),
        details.createdAt && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.createdAt)),
            React.createElement("td", null, moment(details.createdAt).format(THEME.DATE_FORMAT_LONG))))));
};
const InteractionHideFromClientContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    return (React.createElement(React.Fragment, null,
        React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.type)),
            React.createElement("td", null, lang.interactionTypes[details.type] ||
                details.type)),
        details.createdAt && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.createdAt)),
            React.createElement("td", null, moment(details.createdAt).format(THEME.DATE_FORMAT_LONG))))));
};
const InteractionRollbackContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    return (React.createElement(React.Fragment, null,
        React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.type)),
            React.createElement("td", null, lang.interactionTypes[details.type] ||
                details.type)),
        details.createdAt && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.createdAt)),
            React.createElement("td", null, moment(details.createdAt).format(THEME.DATE_FORMAT_LONG))))));
};
const InteractionMappedToCaseContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    return (React.createElement(React.Fragment, null,
        React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.type)),
            React.createElement("td", null, lang.interactionTypes[details.interactionType] ||
                details.interactionType)),
        details.fromCaseId && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.fromCase)),
            React.createElement("td", null, details.fromCaseId)))));
};
const InteractionUnmappedFromCaseContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    return (React.createElement(React.Fragment, null,
        React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.type)),
            React.createElement("td", null, lang.interactionTypes[details.interactionType] ||
                details.interactionType))));
};
//# sourceMappingURL=InteractionDetails.js.map